import { render, staticRenderFns } from "./TournamentHome.vue?vue&type=template&id=c2d4824e&scoped=true"
import script from "./TournamentHome.vue?vue&type=script&lang=js"
export * from "./TournamentHome.vue?vue&type=script&lang=js"
import style0 from "./TournamentHome.vue?vue&type=style&index=0&id=c2d4824e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d4824e",
  null
  
)

export default component.exports